import React from "react";
import FeaturePageLayout from "./FeaturePageLayout";

const cards = [
  {
    bg: "#E6F7FF",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#14B8A6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>,
    title: "Kanban Visual",
    desc: "Gerencie seu pipeline de vendas em colunas drag-and-drop com etapas personalizáveis por produto ou time.",
  },
  {
    bg: "#EFF6FF",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>,
    title: "Qualificação Automática",
    desc: "O chatbot faz as perguntas certas, pontua o lead e move automaticamente para a etapa correta do funil.",
  },
  {
    bg: "#dbeafe",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    title: "Histórico Completo",
    desc: "Cada lead tem uma linha do tempo com todas as interações, mensagens, tags, notas e arquivos trocados.",
  },
  {
    bg: "#fef3c7",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>,
    title: "Relatórios de Vendas",
    desc: "Acompanhe taxa de conversão, tempo médio no funil, volume por agente e projeção de receita em um painel.",
  },
  {
    bg: "#fce7f3",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0EA5E9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
    title: "Transferência Inteligente",
    desc: "Direcione leads qualificados ao vendedor certo por especialidade, disponibilidade ou round-robin automático.",
  },
  {
    bg: "#ffedd5",
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ea580c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/><line x1="9" y1="10" x2="15" y2="10"/></svg>,
    title: "Follow-up Automatizado",
    desc: "Configure lembretes automáticos para contatos parados em uma etapa do funil há mais de X horas ou dias.",
  },
];

const steps = [
  { title: "Capture o lead pelo WhatsApp", desc: "O chatbot recepciona, coleta dados e já cria o contato no CRM sem intervenção manual." },
  { title: "Qualifique com perguntas inteligentes", desc: "Fluxos automáticos identificam interesse, orçamento e urgência e pontuam o lead automaticamente." },
  { title: "Mova no Kanban com arrastar e soltar", desc: "Seus vendedores gerenciam o pipeline visualmente e recebem notificações de leads prontos para fechar." },
  { title: "Feche e gere relatório", desc: "Registro automático do negócio fechado com valor, data e responsável para análise de performance." },
];

const visual = {
  icon: (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#14B8A6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/>
    </svg>
  ),
  label: "Pipeline Kanban",
  sub: "Visualize cada etapa da venda",
};

const FeatureVendas = () => (
  <FeaturePageLayout
    tag="Vendas & CRM"
    title="Venda mais com"
    titleHi="menos esforço"
    sub="Gerencie leads em um Kanban visual, automatize a qualificação e feche negócios mais rápido com histórico completo de cada contato."
    cards={cards}
    steps={steps}
    visual={visual}
  />
);

export default FeatureVendas;
